import React from 'react';
import { motion } from 'framer-motion';
import { Truck, Headphones, Shield, Award } from 'lucide-react';

const services = [
  {
    icon: Truck,
    title: 'Envíos a toda Europa',
    description: 'Entrega rápida y segura'
  },
  {
    icon: Headphones,
    title: 'Asistencia técnica',
    description: 'Soporte experto disponible'
  },
  {
    icon: Shield,
    title: 'Garantía de 5 años',
    description: 'Protección completa'
  },
  {
    icon: Award,
    title: 'Servicio postventa',
    description: 'Atención continua'
  }
];

export function ServiceHighlights() {
  return (
    <section className="py-16 bg-gray-50 border-t border-gray-100">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="flex flex-col items-center text-center group"
            >
              {/* 图标容器 */}
              <div className="w-16 h-16 rounded-full bg-black flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                <service.icon className="w-8 h-8 text-white" />
              </div>

              {/* 标题 */}
              <h3 className="text-lg font-bold text-gray-900 mb-2">
                {service.title}
              </h3>

              {/* 描述 */}
              <p className="text-sm text-gray-600">
                {service.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
